import React, { useEffect, useRef, useState } from 'react';
import { flushSync } from 'react-dom';
import { connect } from 'react-redux';
import { useSwipeable } from 'react-swipeable';

import { togglePopup } from 'actions/appAction';

import { Overlay, PopupBox, PopupBoxInner, PopupOuter } from './styles';

const closePopup = (e, canClose, togglePopup) => {
    if (__isBrowser__ && canClose) {
        e.preventDefault();
        togglePopup(false);
    }
};

const Popup = (props) => {
    const popupRef = useRef(null);
    const [state, setState] = useState({
        isShow: false,
        component: false,
        animationEnd: false,
    });

    useEffect(() => {
        const keyPressHandler = (e) => {
            if (e.keyCode === 27) {
                closePopup(e, props.canClose, props.togglePopup);
            }
        };
        if (props.canClose) {
            document.addEventListener('keydown', keyPressHandler);
            return () => {
                document.removeEventListener('keydown', keyPressHandler);
            };
        }
    }, [props.canClose, props.togglePopup]);

    useEffect(() => {
        if (props.isShowPopup) {
            setState((state) => {
                return {
                    ...state,
                    isShow: true,
                    component: props.component,
                };
            });
        } else if (!props.isShowPopup && props.component) {
            setState((state) => {
                return {
                    ...state,
                    animationEnd: true,
                };
            });
        }
    }, [props.isShowPopup, props.component]);

    const slide = () => {
        if (props.canClose) props.togglePopup(false);
    };

    const handlers = useSwipeable({
        onSwipedDown: () => slide(),
        delta: 20,
        preventDefaultTouchmoveEvent: true,
        trackTouch: true,
    });

    const overlayClick = (e) => {
        if (popupRef.current && !popupRef.current.contains(e.target)) {
            closePopup(e, props.canClose, props.togglePopup);
        }
    };
    const closeAnimationPopup = () => {
        if (!props.isShowPopup) {
            flushSync(() => {
                setState({
                    isShow: false,
                    component: false,
                    animationEnd: false,
                });
            });
        }
    };

    if (state.isShow) {
        return (
            <div id="popup-body" {...handlers}>
                {props.children}
                <Overlay onClick={overlayClick}>
                    <PopupOuter>
                        <PopupBox animated={!props.isShowPopup && state.animationEnd} onAnimationEnd={closeAnimationPopup}>
                            <PopupBoxInner ref={popupRef} isShowSpinner={props.isShowSpinner}>
                                {state.component}
                            </PopupBoxInner>
                        </PopupBox>
                    </PopupOuter>
                </Overlay>
            </div>
        );
    } else {
        return null;
    }
};

const mapStateToProps = (state) => ({
    isShowSpinner: state.app.isShowSpinner,
    isShowPopup: state.app.isShowPopup,
    component: state.app.popupComponent,
    canClose: state.app.canClose,
});

export default connect(mapStateToProps, { togglePopup })(Popup);
